enum CookieAccepts {
  Whitelabels = 'white_labels=labels_white',
  WhitelabelChangeFlow = 'wl=cfPlease',
  Smartpopunders = 'smart_popunders=popunders_smart',
  XlMirror = 'xlMirror=Please',
  FhMirror = 'fhMirror=Please',
  WLAgev = 'wlAgev=Please',
  RedirectURL = 'redirectUrl=Please',
  ThemeAvailable = 'theme=Please',
  AsianWLset = 'asianWLset=Please',
  AvailableForStreaming = 'streamingAvailable=Please',
}

export default CookieAccepts;
